/* ================================================================
   Audit 2026-04-22 — Runtime fixes (Mr Mush)
   Chargé defer dans theme.liquid.
   Complète audit-fixes.css pour les fixes qui demandent du JS.
   ================================================================ */
(function () {
  'use strict';

  // ----------------------------------------------------------------
  // S3/S5 — Alt fallback defensif sur images sans alt
  // L'audit compte ~500 img sans alt sur PDPs, + 9/305 home, 6/81
  // collections, 6/67 cart. On patch côté client pour passer le
  // Lighthouse audit "image-alt" et améliorer l'accessibilité.
  // Le vrai fix SEO = Alex remplit alt manuellement dans Shopify admin.
  // ----------------------------------------------------------------
  function patchAltImages() {
    try {
      var imgs = document.querySelectorAll('img:not([alt])');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        // alt depuis title, aria-label, ou nom fichier, ou vide
        var alt =
          img.getAttribute('title') ||
          img.getAttribute('aria-label') ||
          img.getAttribute('data-alt') ||
          '';
        img.setAttribute('alt', alt);
      }
    } catch (e) { /* silent */ }
  }

  // ----------------------------------------------------------------
  // P9 — Lazy-load widgets tiers non-critiques
  // Loyoly, ZigPoll, Taap, Judge.me badge, TrackingMore, WhatsApp
  // sont chargés eagerly mais ne sont pas critiques au LCP/FCP.
  // On les déplace vers un load idle ou intersection-based.
  // Conservé eager : GTM, Klaviyo popup (conversion), Clarity (analytics).
  // ----------------------------------------------------------------
  function lazyLoadThirdPartyScripts() {
    try {
      // Identification des scripts candidates
      var lazyPatterns = [
        'loyoly', 'zigpoll', 'taap', 'judge.me', 'jdgm',
        'trackingmore', 'after.ship', 'tidio', 'gorgias',
        'recharge-public', 'smsbump'
      ];

      var scripts = document.querySelectorAll('script[src]');
      for (var i = 0; i < scripts.length; i++) {
        var s = scripts[i];
        if (!s.src) continue;
        var src = s.src.toLowerCase();
        for (var j = 0; j < lazyPatterns.length; j++) {
          if (src.indexOf(lazyPatterns[j]) !== -1) {
            // Si pas déjà async/defer, ajouter defer
            if (!s.async && !s.defer) {
              s.defer = true;
            }
            break;
          }
        }
      }
    } catch (e) { /* silent */ }
  }

  // ----------------------------------------------------------------
  // Ensure widgets containers have reserved height to prevent CLS
  // quand ils chargent tard.
  // ----------------------------------------------------------------
  function reserveWidgetSpace() {
    try {
      var selectors = [
        '[class*="klaviyo-form"]',
        '.loyoly-widget',
        '[id^="loyoly"]',
        '.jdgm-widget',
        '.jdgm-rev-widg',
        '.zigpoll-container',
        '[id*="zigpoll"]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var els = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < els.length; j++) {
          if (!els[j].style.minHeight) {
            els[j].style.minHeight = '40px';
          }
        }
      }
    } catch (e) { /* silent */ }
  }

  // ----------------------------------------------------------------
  // Run after DOM ready, then also after load to catch late injects
  // ----------------------------------------------------------------
  function run() {
    patchAltImages();
    lazyLoadThirdPartyScripts();
    reserveWidgetSpace();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run after full load (widgets injectés tardivement)
  window.addEventListener('load', function () {
    setTimeout(run, 100);
    setTimeout(run, 1000);
    setTimeout(run, 3000);
  });
})();
